// 얇은 구분선 섹션 제목 (시안 .sec). props: label, right (우측 보조 노드)
import React from 'react';
import { S, T } from '../theme';

function Sec(props) {
  return (<div className="v2-sec" style={S.secTitle}>
    <span style={{ whiteSpace: 'nowrap' }}>{props.label}</span>
    <span style={{ flex: 1, height: 1, background: T.bd }} />
    {props.right ? <span style={{ fontWeight: 600 }}>{props.right}</span> : null}
  </div>);
}

export default Sec;
